module.exports = __webpack_public_path__ + "img/en_home.6500ef99.png";